import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class HeroParallax {
	constructor() {
		this.section = document.querySelector('[data-hero-parallax]')
		if (!this.section) return

		this.media = this.section.querySelector('[data-hero-parallax-media]')
		if (!this.media) return

		this.#init()
	}

	#init() {
		gsap.to(this.media, {
			yPercent: 50,
			ease: 'none',
			scrollTrigger: {
				trigger: this.section,
				start: 'top top',
				end: 'bottom top',
				scrub: true,
			},
		})
	}
}
